import { useEffect, useState } from 'react';
import { FinancialOption } from '../../@types/codegen/types';
import { gqlQuery } from '../client';
import { PublicApiSettings } from '../config';
import { toLoanOption } from './adapter';
import { CALCULATE_PAYMENT_QUERY } from './queries';
import { CalculatePaymentData } from './types';

export interface LoanVariables {
  financialOptionId?: string | null;
  duration?: number;
  downPayment?: number;
  residual?: number;
}

/** A recalculated loan through iteration.commerce.calculatePayment. */
const useLoanCalculation = (
  publicApi: PublicApiSettings | undefined,
  adId: string,
  { financialOptionId, duration, downPayment, residual }: LoanVariables
) => {
  const [loan, setLoan] = useState<FinancialOption>();
  const [loading, setLoading] = useState(false);
  const skip = !publicApi || duration === undefined || downPayment === undefined;

  useEffect(() => {
    if (skip) return;
    let active = true;
    setLoading(true);
    gqlQuery<CalculatePaymentData>(publicApi.api, CALCULATE_PAYMENT_QUERY, {
      id: adId,
      config: {
        financialOptionId: financialOptionId || undefined,
        duration: Math.round(duration),
        downPayment: Math.round(downPayment),
        residual: residual || 0,
      },
    })
      .then((data) => {
        const payment = data.ads?.byAdId?.iteration?.commerce.calculatePayment;
        if (active && payment) setLoan(toLoanOption(payment));
      })
      .catch(() => undefined)
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [skip, adId, financialOptionId, duration, downPayment, residual]);

  return { loading, loan };
};

export default useLoanCalculation;
